export default __webpack_public_path__ + "static/media/snowy.a0ae7a35.png";